import { sendData } from "@lib/utils/broadcast";
import { DialogCallbackOptions, openDialogWithCallback } from "@lib/utils/dialogHandler";
import { IExpandDialogData } from "@shared/types/expandDialog";
import { DialogErrorCode, DialogEventType, EOfficeDialogMessageType, IDialogModel } from "@lib/utils/dialog";
import { IDialogMessageBase } from "@lib/order/types/OrderEntity";
import { ResourceEntity } from "../../features/resources/services/types/resourceEntity";
import { useResourceService } from "../../features/resources/services/resourceService";
import { useResourceStore } from "../../shared/stores";
import { saveMeetingType } from "../../features/resources/services/useSaveMeetingType";

export const useMainTemplate = () => {
  const { toggleResource } = useResourceService();
  const { setMeetingLabel, meetingLabel: meetingLabelSelected } = useResourceStore();


  const handleDialogCallback = (dialog: IDialogModel, data: IExpandDialogData) => {
    const selectedResources = data.selectedResources.map((resource) => new ResourceEntity(resource));
    if (dialog) {
      dialog.addEventHandler(DialogEventType.DialogEventReceived, (args: any) => {
        if (args.error === DialogErrorCode.Closed) {
          console.log("Dialog was closed by user");
          // Xử lý khi người dùng đóng dialog
        }
      });
      dialog.addEventHandler(DialogEventType.DialogMessageReceived, (args: any) => {
        if (args.message) {
          try {
            const message = JSON.parse(args.message) as IDialogMessageBase;
            switch (message.MessageType) {
              case EOfficeDialogMessageType.ResourceSelected:
                const resourceSelectedJSON: {
                  selectedResources: ResourceEntity[];
                  meetingLabel: number | null;
                } = JSON.parse(message.data || "[]");
                const resourceFromDialog = resourceSelectedJSON.selectedResources.map((resource) => new ResourceEntity(resource));
                const resourceAdded = resourceFromDialog.filter((resource) => !selectedResources.some((r) => r.email === resource.email));
                const resourceRemoved = selectedResources.filter((resource) => !resourceFromDialog.some((r) => r.email === resource.email));
                if(resourceRemoved.length > 0) {
                  resourceRemoved.forEach((resource) => toggleResource(resource, true));
                }
                if(resourceAdded.length > 0) {
                  resourceAdded.forEach((resource) => {
                    if(resource.childResources.length > 0) {
                      setTimeout(() => {
                        toggleResource(resource, false);
                      }, 1000);
                    } else {
                      if(resourceRemoved.length > 0 && resourceRemoved.some((r) => r.childResources.length > 0 && r.childResources.some((c) => c.email === resource.email))) {
                        setTimeout(() => {
                          toggleResource(resource, false);
                        }, 1000);
                      } else {
                        toggleResource(resource, false);
                      }
                    }
                  });
                }
                if(resourceSelectedJSON.meetingLabel && resourceSelectedJSON.meetingLabel !== meetingLabelSelected) {
                  saveMeetingType({
                    uid: data.customUid || "",
                    resourcesIds: resourceFromDialog.map((item) => item.id).join(","),
                    // originalResourceIds: selectedResource.map((item) => item.id).join(","),
                    meetingType: data.meetingLabel?.meetingLabels?.find((item) => item.id === resourceSelectedJSON.meetingLabel)?.name || "",
                    isRecurring: data.recurringDates?.length > 0 ? 1 : 0,
                    isNewMeeting: true,
                    timeZoneName: data.timeZone || "",
                    organizerName: data.mainAttendee?.name || "",
                    organizerEmail: data.mainAttendee?.userEmail || "",
                    startDate: data.startDateTimeUtc || "",
                    endDate: data.endDateTimeUtc || "",
                    globalId: data.globalId || "",
                    isSendMail: false,
                    subject: "",
                  });
                  setMeetingLabel(resourceSelectedJSON.meetingLabel);
                }
                dialog.close();
                break;

              case EOfficeDialogMessageType.CloseDialog:
                console.log("Closing dialog from message");
                dialog.close();
                break;

              default:
                console.log("Unknown message type:", message.MessageType);
            }
          } catch (error) {
            console.error("Error handling message:", error);
          }
        }
      });
    }
  };

  const handleOpenDialogExpand = (url: string, data: IExpandDialogData) => {
    const callbackOptions: DialogCallbackOptions = {
      // Được gọi ngay sau khi dialog mở thành công
      onDialogOpen: (dialog) => {
        handleDialogCallback(dialog, data);
        // // Gửi data test lên dialog sau khi mở
        setTimeout(() => {
          sendData({
            type: "expandDialogData",
            data: JSON.stringify(data),
          });
        }, 2000);
      },

      // Callback khi dialog đóng
      onDialogClosed: () => {
        console.log("Dialog was closed");
      },
    };

    openDialogWithCallback(url, {
      width: 90,
      height: 80,
      callbackOptions,
    })
      .then((dialog) => {
        console.log("Dialog opened successfully");
      })
      .catch((error) => {
        console.error("Error opening dialog:", error);
      });
  };

  return {
    handleOpenDialogExpand,
  };
};
